/**
 * Configuración centralizada para los tipos de items de fórmula
 * Tipos: M (Materia Prima), R (Recurso), S (Semi-elaborado), P (Producto)
 */
export const FORMULA_ITEM_TYPE_CONFIG = {
  M: {
    id: 'M',
    name: 'Materia Prima',
    entityKey: 'raw_material',
    unitKey: 'storage_unit',
    descriptionPath: 'raw_material.name',
    costPath: 'raw_material.product_presentation.base_price',
    requiresPresentation: true,
    validationName: 'Materia Prima',
    listKey: 'raw_materials',
    loadMethod: 'loadRawMaterials',
  },
  R: {
    id: 'R',
    name: 'Recurso',
    entityKey: 'resource',
    unitKey: 'resource_unit',
    descriptionPath: 'resource.name',
    costPath: 'resource.costo_unitario',
    requiresPresentation: false,
    validationName: 'Recurso',
    listKey: 'resources',
    loadMethod: 'loadResources',
  },
  S: {
    id: 'S',
    name: 'Semi-elaborado',
    entityKey: 'formula_semi',
    unitKey: null,
    descriptionPath: 'formula_semi.name',
    costPath: null,
    requiresPresentation: false,
    validationName: 'Formula Semi-elaborada',
    listKey: 'formulas',
    loadMethod: 'loadFormulas',
  },
  P: {
    id: 'P',
    name: 'Producto',
    entityKey: 'product',
    unitKey: 'storage_unit',
    descriptionPath: 'product.label',
    costPath: 'product.base_price',
    requiresPresentation: false,
    validationName: 'Producto',
    listKey: 'products',
    loadMethod: 'loadProducts',
  },
};

export default FORMULA_ITEM_TYPE_CONFIG;
